// The existing product-level estimate, expressed consistently in kWh, litres
// and grams of CO2. This is not a measurement of the selected harvest batch.
export function productFootprint(product, size) {
  if (![product.tray, product.water, product.emissionFactor, size].every(Number.isFinite) ||
      product.tray <= 0 || size <= 0 || product.water < 0 || product.emissionFactor < 0) return null;
  const fraction = size / product.tray;
  const power = Number((36 * fraction * 16 * 5 / 1000).toFixed(2));
  const water = Number((product.water * fraction * 3).toFixed(2));
  const electricity = power * 12;
  const waterEmissions = water * 0.045;
  const other = Math.abs(waterEmissions - electricity) / 2 * product.emissionFactor;
  const total = electricity + waterEmissions + other;
  return { power, water, electricity, waterEmissions, other, total, perKg: total / (size / 1000) };
}
